// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z543","col":"styles_col__5bw3X"};